import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { banners } from '@/mocks/comics';

export default function HeroBanner() {
  const [current, setCurrent] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const goTo = useCallback((index: number) => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrent(index);
    setTimeout(() => setIsTransitioning(false), 500);
  }, [isTransitioning]);

  useEffect(() => {
    const timer = setInterval(() => {
      goTo((current + 1) % banners.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [current, goTo]);

  const banner = banners[current];

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      {banners.map((b, i) => (
        <div
          key={b.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            i === current ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={b.cover}
            alt={b.title}
            className="w-full h-full object-cover object-center"
          />
        </div>
      ))}

      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/50 via-foreground-950/25 to-foreground-950/70"></div>

      <div className="absolute bottom-0 left-0 right-0 w-full">
        <div className="max-w-7xl mx-auto px-4 md:px-8 pb-12 md:pb-20">
          <div className="animate-fade-in" key={current}>
            <span className="inline-block px-3 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-full mb-4">
              热门推荐
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-background-50 font-heading mb-3">
              {banner.title}
            </h2>
            <p className="text-background-50/80 text-sm md:text-base max-w-lg mb-6">
              {banner.subtitle}
            </p>
            <Link
              to={`/comic/${banner.comicId}`}
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-full transition-colors whitespace-nowrap cursor-pointer"
            >
              立即阅读
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 right-8 flex items-center gap-2">
        {banners.map((_, i) => (
          <button
            key={i}
            onClick={() => goTo(i)}
            className={`w-2.5 h-2.5 rounded-full transition-all cursor-pointer ${
              i === current
                ? 'bg-primary-500 w-8'
                : 'bg-background-50/40 hover:bg-background-50/70'
            }`}
          />
        ))}
      </div>

      <button
        onClick={() => goTo((current - 1 + banners.length) % banners.length)}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center bg-background-50/15 hover:bg-background-50/30 text-background-50 rounded-full transition-colors cursor-pointer"
      >
        <i className="ri-arrow-left-s-line text-lg md:text-xl"></i>
      </button>
      <button
        onClick={() => goTo((current + 1) % banners.length)}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center bg-background-50/15 hover:bg-background-50/30 text-background-50 rounded-full transition-colors cursor-pointer"
      >
        <i className="ri-arrow-right-s-line text-lg md:text-xl"></i>
      </button>
    </section>
  );
}